import { getTimestampWithMilliseconds } from '@app/utils/dateUtils';
import { DEFAULT_LANGUAGE } from '@app/utils/languages';
import sanitizeHtml from 'sanitize-html';

import { GenericObject, MultiLingualObj } from '@app/components/common/Table/DefaultTable/types';

import { FIELD_TYPES } from './validateUtils';

export const formFields = [
  { key: 'title', type: FIELD_TYPES.MULTILINGUAL, message: 'Title is required' },
  { key: 'description', type: FIELD_TYPES.MULTILINGUAL, message: 'Description is required' },
  { key: 'about', type: FIELD_TYPES.MULTILINGUAL, message: 'About is required' },
];

export const nonRequiredFields = [
  { key: 'key_points_body', emptyValue: '', isMultilingual: true },
  { key: 'key_points_title', emptyValue: '', isMultilingual: true },
  { key: 'terms_and_conditions', emptyValue: '', isMultilingual: true },
  { key: 'keywords', emptyValue: '', isMultilingual: true },
  { key: 'expert_ids', emptyValue: [] },
  { key: 'company_ids', emptyValue: [] },
  { key: 'topic_ids', emptyValue: [] },
];

export const getEventPayload = (
  values: GenericObject,
  agenda: GenericObject[],
  selected: GenericObject[],
  sponsorLogo: File | undefined,
  eventLogo: File | undefined
) => {
  return {
    ...values,
    start_time: getTimestampWithMilliseconds(values.start_time),
    end_time: getTimestampWithMilliseconds(values.end_time),
    terms_and_conditions: {
      [DEFAULT_LANGUAGE]: sanitizeHtml((values.terms_and_conditions as MultiLingualObj)[DEFAULT_LANGUAGE] as string),
    },
    agenda,
    event_questions: selected.map((item, index) => ({
      ...item,
      is_mandatory: item.required,
      question_id: item.id,
      position: index,
    })),
    sponsor: sponsorLogo,
    logo: eventLogo,
  };
};
